import { svgInfoTwLogoUnder15, svgInfoTwLogoForAll } from '../../SvgCode';
import { ITwInfoData } from '../../../interface/IFooter';

import DataStore from '../../DataStore';

export default class infoTW {
  private ds: DataStore;

  constructor(_wrapper: HTMLElement) {
    this.ds = DataStore.instance;
    const infoData = this.getInfoData(this.ds.service);

    this.templ(_wrapper, infoData);
  }

  templ(_parent: HTMLElement, infoData: ITwInfoData) {
    _parent.classList.add('footer-info-tw');
    _parent.innerHTML = `
        <div class="info-inner">
            <span class="info-img">${infoData.logo}</span>
            <p class="info-text"> ${infoData.text} </p>
        </div>
        `;
  }

  getInfoData(_service: string) {
    let data: ITwInfoData = {
      text: '',
      logo: svgInfoTwLogoUnder15,
    };

    if (_service === 'breakers') {
      data.text = `
        本遊戲情節涉及暴力、菸酒。<br>
        注意使用時間，避免沉迷於遊戲，可能影響身心健康。<br>
        本遊戲部分內容或服務需另行支付其他費用。
    `;
      data.logo = svgInfoTwLogoUnder15;
    } else {
      data.text = `
        本遊戲情節涉及性、暴力、恐怖。<br>
        注意使用時間，避免沉迷於遊戲，可能影響身心健康。<br>
        本遊戲部分內容或服務需另行支付其他費用。
    `;
      data.logo = svgInfoTwLogoUnder15;
    }

    return data;
  }
}
